import React from 'react'

function BlogHeader() {
  return (
    <div className="heading heading-blog">
      <div>
        <h2>#readmore</h2>
        <p>Read all case studies about our products!</p>
      </div>
    </div>
  );
}

export default BlogHeader